import { TripService } from '@/modules/trip/trip-service';
import Errors from '@/shared/error/errors';
import { routerAsync } from '@/app-module';

// import lodash from 'lodash';
import FirebaseRepository from '@/shared/firebase/firebase-repository';
import { firestoreAction, vuexfireMutations } from 'vuexfire'
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'

export default {
  namespaced: true,

  state: {
    loading: false,
    record: null,
    owner: null,
    loadingOwner: false,
  },

  getters: {
    record: (state) => state.record,
    loading: (state) => !!state.loading,
    owner: (state) => state.owner,
    loadingOwner: (state) => !!state.loadingOwner,
  },

  mutations: {
    // adds Vuexfire built-in mutations
    ...vuexfireMutations,
    VUEXFIRE_FIND_SUCCESS(state) {
      state.loading = false;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.loading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.loading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.loading = false;
    },

    VUEXFIRE_FIND_OWNER_SUCCESS(state) {
      state.loadingOwner = false;
    },

    FIND_OWNER_STARTED(state) {
      state.owner = null;
      state.loadingOwner = true;
    },

    FIND_OWNER_SUCCESS(state, payload) {
      state.owner = payload;
      state.loadingOwner = false;
    },

    FIND_OWNER_ERROR(state) {
      state.owner = null;
      state.loadingOwner = false;
    },
  },

  actions: {
    doFindByVuexfire: firestoreAction(async (context, id) => {
      try {
        context.commit('FIND_STARTED');

        const customSerializer = (doc) => {
          const data = FirebaseRepository.mapDocument(doc)
          Object.defineProperty(data, '_doc', { value: doc })
          return data
        }

        const db = firebase.firestore()
        const TripQuery = db.collection('trip').doc(id)
          
        await context.bindFirestoreRef(
          'record',
          TripQuery,
          { serialize: customSerializer }
        )
        
        context.commit('VUEXFIRE_FIND_SUCCESS');
      } catch (error) {
        Errors.handle(error);
        context.commit('FIND_ERROR');
        routerAsync().push('/trip');
      }
    }),

    doFindOwnerByVuexfire: firestoreAction(async (context, { collectionName, id }) => {
      try {
        context.commit('FIND_OWNER_STARTED');

        const customSerializer = (doc) => {
          const data = FirebaseRepository.mapDocument(doc)
          Object.defineProperty(data, '_doc', { value: doc })
          return data
        }

        const db = firebase.firestore()
        const Query = db.collection(collectionName).doc(id)
          
        await context.bindFirestoreRef(
          'owner',
          Query,
          { serialize: customSerializer }
        )
        
        context.commit('VUEXFIRE_FIND_OWNER_SUCCESS');
      } catch (error) {
        Errors.handle(error);
        context.commit('FIND_OWNER_ERROR');
        routerAsync().push('/trip');
      }
    }),

    async doFind({ commit }, id) {
      try {
        commit('FIND_STARTED');
        const record = await TripService.find(id);
        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/trip');
      }
    },
  },
};

